import React, { useState, useEffect } from "react";
import { useForm, Controller } from "react-hook-form";

import useSkeleton from "../../../../hooks/useSkeleton";

import "react-toastify/dist/ReactToastify.css";

import useCommonState from "../../../../hooks/useCommonState";
import BeneficiaryCredits from "./beneficiaryCredits";

const BeneficiaryPaymentDialog = () => {
  const { isLoading, setIsLoading, setToastConfig, t } = useCommonState();

  const s = useSkeleton("abm");

  return (
    <React.Fragment>
      <div className={s.get()}>
        <BeneficiaryCredits />
      </div>
    </React.Fragment>
  );
};

export default BeneficiaryPaymentDialog;
